import React, { useRef, useState } from "react";
import { Section, Main } from "../../../components/content";
import { PERMISSIONS } from "../../../utils/permissions";
import SelectCustom from "../../../components/customSelect/CustomSelect";
import LoadingPlaceholder from "../../../components/loadingPlaceholder/LoadingPlaceholder";
import { getGroceryPermissions, getPharmacyPermissions } from '../../../middleware';
import { useLocation } from "react-router-dom";
import { slugify } from "../../../helpers/helpers";
import { useAuth } from "../../../context/useAuth";
import { useCallback, useEffect } from "react";
import jwt_decode from "jwt-decode";
import Table from "./Table";
import Loading from "../../../components/loading/Loading";
import SidebarModal from "../../../components/sidebarModal/SidebarModal";
import { notification } from "antd";
import Modal from "../../../components/modal/Modal";
import { AXIOS_API_CALL } from "../../../utils/endpoint";
import { SERVER_URL } from "../../../config/index";
import axios from "axios";
import { notificationMessages } from "../../../helpers/notificationMessages";

const options = [5, 10, 20, 50, 100];

const GeoLocation = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [pharmacyPermissions, setPharmacyPermissions] = useState([]);

  // GET USER TOKEN
  useEffect(() => {
    const { token } = user;
    if (user && token) {
      const decodeToken = jwt_decode(token);
      const permissions = decodeToken.roleData?.permissions;

      if (location.pathname.includes(`/${PERMISSIONS.dashboard}/${PERMISSIONS.pharmacy}`)) {
        if (Object.keys(permissions).some((permission) => permission.includes(PERMISSIONS.pharmacy))) {
          // Change permissions.grocery to permissions.pharmacy
          setPharmacyPermissions(permissions.grocery);
        }
      }
    }
  }, [user, location]);

  // SEARCH
  const [search, setSearch] = useState(null);
  const [searchForm, setSearchForm] = useState({
    query: "",
  });

  const handleOnSubmitSearch = (e) => {
    e.preventDefault();
    setSearch(searchForm.query);
    setReadDataRefetch((prevState) => !prevState);
  };

  const handleOnChangeSearch = (value) => {
    setSearchForm({ query: value });
  };

  // PAGE
  const [readData, setReadData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limitPage, setLimitPage] = useState(10);

  // READ
  const [readDataRefetch, setReadDataRefetch] = useState(false);
  const [readDataLoading, setReadDataLoading] = useState(true);

  const handleOnClearSearch = () => {
    setSearch(null);
    setSearchForm({ query: "" });
    setReadDataRefetch((prevState) => !prevState);
  };
  const getReadData = useCallback(() => {
    const { token } = user;

    try {
      const response = axios
        .get(
          `${SERVER_URL}/${
            AXIOS_API_CALL.getGeoLocations
          }/${currentPage}/${limitPage}/${search || null}`,
          {
            withCredentials: false,
            headers: {
              Authorization: `Bearer ${token}`,
              department: PERMISSIONS.pharmacy,
            },
          }
        )
        .then((res) => {
          setTimeout(() => {
            setReadDataLoading(false);
          }, 200);
          return res;
        })
        .catch((err) => console.error(err))
        .finally();

      return response;
    } catch (err) {}
  }, [user, currentPage, limitPage, search]);

  useEffect(() => {
    let isMounted = true;
    new Promise((resolve, reject) => {
      setReadDataLoading(true);
      setTimeout(() => {
        resolve(getReadData());
      }, 700);
    }).then((res) => {
      if (isMounted) {
        setReadData(res?.data);
      }
    });
    return () => {
      isMounted = false;
    };
  }, [getReadData, readDataRefetch]);

  // LOADER PROTECTION
  const [createBtnLoader, setCreateBtnLoader] = useState(false);
  const [deleteBtnLoader, setDeleteBtnLoader] = useState(false);

  // CREATE - (geo location)
  const createFormRef = useRef(null);
  const [toggleCreate, setToggleCreate] = useState(false);
  const [createForm, setCreateForm] = useState({
    zip_code: "",
    slug: "",
  }); // FORM data
  const [createFormError, setCreateFormError] = useState({
    zip_code: false,
  }); // ERROR handling

  // CREATE GEO LOCATION
  const [toggleCreateGeoLocation, setToggleCreateGeoLocation] = useState(false);

  useEffect(() => {
    if (!!toggleCreateGeoLocation) {
      setToggleCreateGeoLocation(false);
    }
  }, [toggleCreate]);

  // CREATE - (unit)
  const createUnitFormRef = useRef(null);
  const [toggleCreateUnit, setToggleCreateUnit] = useState(false);
  const [createUnitForm, setCreateUnitForm] = useState({ name: "" }); // FORM data

  // DELETE
  const deleteFormRef = useRef(null);
  const [toggleDelete, setToggleDelete] = useState(false);
  const [deleteFormId, setDeleteFormId] = useState({ id: "" }); // ID for fetch

  // DELETE BULK
  const deleteBlukModalFormRef = useRef(null);
  const [toggleDeleteBulk, setToggleDeleteBulk] = useState(false);

  // Get selected rows id one or more
  const [checkedRow, setCheckedRow] = useState([]);
  const handleCheckedRows = (data) => {
    setCheckedRow(data);
  };
  // FILTERS
  const [disabledButton, setDisabledButton] = useState(false);
  const handleDisabledButton = (status) => {
    setDisabledButton(status);
  };

  const handleToggle = (props) => {
    const { name, data } = props;

    switch (name) {
      case "create":
        setToggleCreate(true);
        break;
      case "delete":
        setToggleDelete(true);
        setDeleteFormId({ id: data._id });
        break;
      case "deleteBulk":
        setToggleDeleteBulk(true);
        break;
      default:
        console.warn("Default of: handleToggle function");
    }
  };
  const handleOnBlur = (event) => {
    const { name, value } = event.target;

    switch (name) {
      case "create_zip_code":
        if (value.length === 5) {
          setCreateFormError({ ...createFormError, zip_code: false });
        } else {
          toggleCreate
            ? setCreateFormError({ ...createFormError, zip_code: true })
            : setCreateFormError({ ...createFormError, zip_code: false });
        }
        break;
      default:
        console.warn("Default of: handleOnBlur function!");
    }
  };
  const handleOnChange = (event) => {
    const { name, value } = event.target;

    switch (name) {
      case "create_zip_code":
        const slug = slugify(value);
        if (value.includes(" ") || value < 0) return;
        setCreateForm({ ...createForm, zip_code: value, slug: slug });
        break;
      default:
        console.warn("Default of: handleOnChange function!");
    }
  };

  /**
   * Handle validate function
   * @param {name}
   * @param {form}
   */
  const handleOnValidate = ({ name, form }) => {
    let checkCase = false;

    let checkCreateZipCode = false;

    switch (name) {
      case "create":
        if (form.data.zip_code.length === 5) {
          checkCreateZipCode = true;
          setCreateFormError((prev) => {
            return {
              ...prev,
              zip_code: false,
            };
          });
        } else {
          checkCreateZipCode = false;
          toggleCreate
            ? setCreateFormError((prev) => {
                return {
                  ...prev,
                  zip_code: true,
                };
              })
            : setCreateFormError((prev) => {
                return {
                  ...prev,
                  zip_code: true,
                };
              });
        }
        if (!checkCreateZipCode) {
          setCreateFormError({
            ...createFormError,
            zip_code: true,
          });
        }

        if (checkCreateZipCode) {
          checkCase = true;
        }
        break;
      case "delete":
        checkCase = true;
        break;
      case "deleteBulk":
        checkCase = true;
        break;
      default:
        console.warn("Default of: handleOnValidate function!");
    }
    return checkCase;
  };

  /**
   * Form submit function
   * @param {*} props
   */
  async function handleOnSubmit({ event, form }) {
    event.preventDefault();

    const { name } = event.target;

    const { token } = user;

    switch (name) {
      case "create":
        setCreateBtnLoader(true);
        const createValidate = handleOnValidate({ name: name, form: form });

        if (createValidate) {
          let createPayload = {
            zip_code: form.data.zip_code,
          };
          try {
            axios
              .post(
                `${SERVER_URL}/${AXIOS_API_CALL.createGeoLocations}`,
                createPayload,
                {
                  withCredentials: false,
                  headers: {
                    department: PERMISSIONS.pharmacy,
                    Authorization: `Bearer ${token}`,
                  },
                }
              )
              .then((res) => {
                if (res.status === 201) {
                  setReadDataRefetch((prevState) => !prevState);
                  form.onToggle(false);
                  form.onData({
                    zip_code: "",
                    slug: "",
                  });
                  form.formRef.current.reset();

                  // notification
                  notification.success({
                    message: notificationMessages.successCreateGeoLocation,
                    placement: "bottomLeft",
                  });
                  setTimeout(() => {
                    setCreateBtnLoader(false);
                  }, 400);
                }
              })
              .catch((err) => {
                console.error(err);
                setCreateBtnLoader(false);
              })
              .finally(setTimeout(() => {}, 700));
          } catch (err) {
            console.error(err);
          }
        } else {
          setCreateBtnLoader(false);
        }
        break;
      case "delete":
        setDeleteBtnLoader(true);
        const deleteValidate = handleOnValidate({ name: name, form: form });

        if (deleteValidate) {
          const deleteID = deleteFormId.id;

          try {
            await axios
              .delete(
                `${SERVER_URL}/${AXIOS_API_CALL.deleteGeoLocation}/${deleteID}`,
                {
                  withCredentials: false,
                  headers: {
                    department: PERMISSIONS.pharmacy,
                    Authorization: `Bearer ${token}`,
                  },
                }
              )
              .then((res) => {
                if (res.status === 200) {
                  setReadDataRefetch((prevState) => !prevState);
                  setDeleteFormId({ id: "" });
                  form.onToggle(false);
                  form.formRef.current.reset();

                  notification.success({
                    message: res.data.message,
                    placement: "bottomLeft",
                  });
                  // setDeleteBtnLoader(false);
                  setTimeout(() => {
                    setDeleteBtnLoader(false);
                  }, 400);
                }
              })
              .catch((err) => {
                setDeleteBtnLoader(false);
              })
              .finally(setTimeout(() => {}, 700));
          } catch (err) {
            console.error(err);
          }
        } else {
          setDeleteBtnLoader(false);
        }
        break;
      case "deleteBulk":
        setDeleteBtnLoader(true);
        const isValidateBulkDelete = handleOnValidate({
          name: name,
          form: form,
        });
        const bulkPayload = {
          zip_codes: checkedRow,
        };
        if (isValidateBulkDelete) {
          await axios
            .post(
              `${SERVER_URL}/${AXIOS_API_CALL.deleteBulkGeoLocations}`,
              bulkPayload,
              {
                withCredentials: false,
                headers: {
                  Authorization: `Bearer ${token}`,
                  department: PERMISSIONS.pharmacy,
                },
              }
            )
            .then((res) => {
              if (res.status === 200) {
                setReadDataRefetch((prev) => !prev);
                setToggleDeleteBulk(false);
                setTimeout(() => {
                  setDeleteBtnLoader(false);
                }, 400);
              }
            })
            .catch((err) => {
              console.error(err);
            });
        }
        break;
      default:
        console.warn("Default of: handleOnSubmit function!");
    }
  }

  // CREATE COUPON PROPS
  const createProps = {
    active: toggleCreate,
    onToggle: setToggleCreate,
    formRef: createFormRef,
    data: createForm,
    onData: setCreateForm,
  };

  // DELETE PROPS
  const deleteProps = {
    active: toggleDelete,
    onToggle: setToggleDelete,
    formRef: deleteFormRef,
  };

  // PAGINATION
  const paginationProps = {
    current: currentPage,
    setCurrentPage: setCurrentPage,
    limitPage: limitPage,
    buttonLimit: 3,
    pagesCount: readData?.data?.pagesCount,
    totalCount: readData?.data?.totalCount,
  };

  // TABLE PROPS
  const tableProps = {
    handleDisabledButton: handleDisabledButton,
    handleCheckedRows: handleCheckedRows,
  };

  // TABLE ACTIONS PROPS
  const tableActionsProps = {
    handleToggle: handleToggle,
    deleteProps: deleteProps,

    location: location,
    pharmacyPermissions: pharmacyPermissions,
    getPharmacyPermissions: getPharmacyPermissions,
  };

  // delete bulk
  const deleteBlukProps = {
    active: toggleDeleteBulk,
    onToggle: setToggleDeleteBulk,
    formRef: deleteBlukModalFormRef,
  };

  return (
    <>
      <h2 className="page-title">Geo Locations</h2>
      <Section className="section__wrapper section__coupons">
        <header className="section__header">
          {!readDataLoading ? (
            <div className="filter">
              <span
                style={{
                  color: "#333",
                  fontWeight: "500",
                }}
              >
                Show:
              </span>
              <SelectCustom
                options={options}
                label={"Items"}
                limit={limitPage}
                setLimit={setLimitPage}
                setRefetch={setReadDataRefetch}
                loading={readDataLoading}
              />
            </div>
          ) : (
            <LoadingPlaceholder style={{ width: "155.5px", height: "50px" }} />
          )}

          {!readDataLoading ? (
            <div className="search">
              <form
                className="search-form"
                onSubmit={(e) => handleOnSubmitSearch(e)}
                data-cy="search-roles"
              >
                <div className="form-group m-0">
                  <span className="icon icon-search">
                    <img
                      src="/assets/icons/search.svg"
                      alt="Search"
                      title="Search"
                    />
                  </span>
                  <input
                    value={searchForm.query || ""}
                    type="text"
                    data-cy="search-input-field"
                    className="input"
                    placeholder="Search"
                    onChange={(e) => handleOnChangeSearch(e.target.value)}
                  />
                  <span
                    className={`icon icon-close ${
                      !!searchForm.query && searchForm.query.length > 0
                        ? "isActive"
                        : ""
                    }`}
                    onClick={() => handleOnClearSearch()}
                  >
                    <img
                      src="/assets/icons/times.svg"
                      alt="Clear"
                      title="Clear"
                    />
                  </span>
                </div>
                <button className="form-submit" data-cy="search-submit-btn">
                  Search
                </button>
              </form>
            </div>
          ) : (
            <LoadingPlaceholder
              style={{
                width: "100%",
                maxWidth: "850px",
                height: "50px",
              }}
            />
          )}

          <div className="actions">
            {getPharmacyPermissions(
              pharmacyPermissions,
              PERMISSIONS.deleteGeoLocations
            ) && (
              <>
                {!readDataLoading ? (
                  <button
                    type="button"
                    onClick={() =>
                      handleToggle({
                        name: "deleteBulk",
                        state: deleteBlukProps,
                      })
                    }
                    disabled={disabledButton ? false : true}
                    data-cy="delete-products-btn"
                    className="btn btn-primary-outline pl-4 pr-4"
                  >
                    <span className="text">Delete Geo Locations</span>
                  </button>
                ) : (
                  <LoadingPlaceholder
                    style={{ width: "189px", height: "50px" }}
                  />
                )}
              </>
            )}

            {getPharmacyPermissions(
              pharmacyPermissions,
              PERMISSIONS.createGeoLocations
            ) && (
              <>
                <div className="actions">
                  {!readDataLoading ? (
                    <button
                      type="button"
                      onClick={() =>
                        handleToggle({
                          name: "create",
                          state: createProps,
                        })
                      }
                      data-cy="create-attribute-btn"
                      className="btn btn-primary pl-4 pr-4"
                    >
                      <span className="text">Create Geo Location</span>
                    </button>
                  ) : (
                    <LoadingPlaceholder
                      style={{
                        width: "191px",
                        height: "50px",
                      }}
                    />
                  )}
                </div>
              </>
            )}
          </div>
        </header>
        <Main className="section__content relative min-h-table-content">
          {readDataLoading ? (
            <Loading />
          ) : (
            <Table
              data={readData.data?.Data}
              {...tableProps}
              {...tableActionsProps}
              pagination={paginationProps}
            />
          )}
        </Main>

        {/* CREATE COUPON */}
        {getPharmacyPermissions(
          pharmacyPermissions,
          PERMISSIONS.createGeoLocations
        ) && (
          <SidebarModal
            {...createProps}
            className="sidebar__modal--right"
            title="Create Geo Location"
          >
            <form
              name="create"
              ref={createFormRef}
              className="ant-form ant-form-horizontal mb-2"
              onSubmit={(event) =>
                handleOnSubmit({ event: event, form: createProps })
              }
            >
              <div className="form-group relative">
                <label className="label mb-1 d-block" htmlFor="create_zip_code">
                  <b className="required">Geo Location:</b>
                </label>

                <input
                  type="number"
                  placeholder="Zip code"
                  name="create_zip_code"
                  id="create_zip_code"
                  data-cy="create-attribute-name-input"
                  value={createForm.zip_code || ""}
                  onChange={(event) => handleOnChange(event)}
                  onBlur={(event) => handleOnBlur(event)}
                  className={`input ${
                    createFormError.zip_code ? "input-error" : ""
                  }`}
                />

                <p
                  data-cy="modal-create-attribute-name-error"
                  className={`error__onblur ${
                    createFormError.zip_code ? "error" : ""
                  }`}
                >
                  * This field is required! (zip code must be 5 numbers)
                </p>
              </div>

              {!toggleCreateGeoLocation && (
                <div className="form-group form-group-sidebar">
                  <button
                    data-cy="modal-create-cancel-btn"
                    type="button"
                    className="btn btn-primary-link"
                    onClick={() => setToggleCreate(false)}
                  >
                    <span className="text">Cancel</span>
                  </button>

                  {!createBtnLoader ? (
                    <button
                      data-cy="modal-create-submit-btn"
                      type="submit"
                      className="btn btn-primary"
                    >
                      <span className="text">Create Geo Location</span>
                    </button>
                  ) : (
                    <button type="button" className="btn btn-primary-outline">
                      <span className="text">Creating...</span>
                    </button>
                  )}
                </div>
              )}
            </form>
          </SidebarModal>
        )}

        {/* Delete Bulk Modal */}
        <Modal {...deleteBlukProps} className="sidebar__modal--center" title="">
          <form
            name="deleteBulk"
            onSubmit={(event) =>
              handleOnSubmit({
                event: event,
                name: "deleteBulk",
                data: checkedRow,
              })
            }
          >
            <h2 className="text-center mb-4">
              Are you sure you want to remove selected items ?
            </h2>

            <div className="form-group form-group-modal mb-4">
              <button
                data-cy="modal-delete-bulk-submit-btn"
                type="submit"
                className="btn btn-primary-link"
              >
                <span className="text">Yes</span>
              </button>

              <button
                data-cy="modal-delete-bulk-cancel-btn"
                type="button"
                className="btn btn-primary"
                onClick={() => setToggleDeleteBulk(false)}
              >
                <span className="text">No</span>
              </button>
            </div>
          </form>
        </Modal>

        {/* Delete */}
        {getPharmacyPermissions(
          pharmacyPermissions,
          PERMISSIONS.deleteGeoLocations
        ) && (
          <Modal {...deleteProps} className="sidebar__modal--center" title="">
            <form
              name="delete"
              ref={deleteFormRef}
              className="ant-form ant-form-horizontal"
              onSubmit={(event) =>
                handleOnSubmit({ event: event, form: deleteProps })
              }
            >
              <h2 className="text-center mb-4">
                Are you sure you want to delete the selected item ?
              </h2>

              <div className="form-group form-group-modal mb-4">
                {!deleteBtnLoader ? (
                  <button
                    data-cy="modal-delete-submit-btn"
                    type="submit"
                    className="btn btn-primary-link"
                  >
                    <span className="text">Yes</span>
                  </button>
                ) : (
                  <button type="button" className="btn btn-primary-outline">
                    <span className="text">Deleting...</span>
                  </button>
                )}

                <button
                  data-cy="modal-delete-cancel-btn"
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setToggleDelete(false)}
                >
                  <span className="text">No</span>
                </button>
              </div>
            </form>
          </Modal>
        )}
      </Section>
    </>
  );
};
export default GeoLocation;
